import './Modal.css';
import React, { useEffect, createRef } from 'react'; // eslint-disable-line

import { ReactComponent as IconClose } from '../../../resources/icons/close.svg';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import ReactDOM from 'react-dom';
import clsx from 'clsx';
import { canUseDOM } from '../../../utils';
var Modal = function Modal(_ref) {
  var isShown = _ref.isShown,
    hide = _ref.hide,
    style = _ref.style,
    children = _ref.children,
    primaryColor = _ref.primaryColor,
    primaryActiveColor = _ref.primaryActiveColor,
    _ref$fullPageCover = _ref.fullPageCover,
    fullPageCover = _ref$fullPageCover === void 0 ? false : _ref$fullPageCover,
    _ref$fullPageVideo = _ref.fullPageVideo,
    fullPageVideo = _ref$fullPageVideo === void 0 ? false : _ref$fullPageVideo,
    _ref$showMobileClose = _ref.showMobileClose,
    showMobileClose = _ref$showMobileClose === void 0 ? false : _ref$showMobileClose;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var modalRef = /*#__PURE__*/createRef();
  var variables = {
    '--modal-primary-color': primaryColor || 'var(--main-color)',
    '--modal-primary-active-color': primaryActiveColor || 'var(--main-color--active)'
  };
  var onModalClose = function onModalClose(e) {
    if (isShown) {
      hide();
    }
  };
  useEffect(function () {
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
      isShown ? document.querySelector('html').style.overflow = 'hidden' : document.querySelector('html').style.overflow = 'unset';
      var keyListener = function keyListener(e) {
        var listener = keyListenersMap.get(e.keyCode);
        return listener && listener(e);
      };
      document.addEventListener('keydown', keyListener);
      return function () {
        return document.removeEventListener('keydown', keyListener);
      };
    }
  });
  useEffect(function () {
    if (canUseDOM) {
      var node = modalRef.current;
      if (node && isShown) {
        node.focus();
      }
    }
  }, [isShown]);
  var keyListenersMap = new Map([[27, onModalClose]]);
  var modal = /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    style: variables
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: clsx('modal-backdrop', {
      'full-page-video-backdrop': fullPageVideo
    }),
    onClick: hide
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx('modal', {
      'full-page': fullPageCover
    }, {
      'full-page-video': fullPageVideo
    }, {
      'mobile-close-visible': showMobileClose
    }),
    style: style
  }, ' ', /*#__PURE__*/React.createElement("div", {
    className: "modal-inner",
    tabIndex: 0,
    ref: modalRef,
    "aria-modal": true,
    "aria-labelledby": "modal",
    role: "dialog"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal__header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "modal__close-btn",
    type: "button",
    onClick: hide,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(IconClose, {
    tabIndex: -1
  }))), /*#__PURE__*/React.createElement("div", {
    className: "modal__content"
  }, " ", children)))));
  return isShown ? /*#__PURE__*/ReactDOM.createPortal(modal, document.body) : null;
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    style = _ref2.style;
  return /*#__PURE__*/React.createElement("div", {
    className: "  ".concat(eventStyle, "  ").concat(rtl ? rtlStyle : ltlStyle, " "),
    style: style
  }, children);
};
var eventStyle = "efuyw27";
var rtlStyle = "r115be6b";
var ltlStyle = "lbe585r";
export default Modal;